export default __webpack_public_path__ + "static/media/centris_data_transfer_modal_en.918c4d0c.png";